/* HealthyHeads — homepage
   Voorlopig alleen de hero. Wisselen van slide kan uitsluitend via de
   knopjes: geen vegen, geen klik op de slide zelf. */
(function () {
  "use strict";

  function initHero(root) {
    if (root.dataset.hhHeroInit === "1") return;
    root.dataset.hhHeroInit = "1";

    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hh-dot]"));
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hh-slide]"));
    if (dots.length < 2) return;

    var rustig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function markeerDots(id) {
      dots.forEach(function (d) {
        var actief = d.dataset.target === id;
        d.classList.toggle("is-active", actief);
        d.setAttribute("aria-selected", actief ? "true" : "false");
      });
    }

    // De slides liggen over elkaar in dezelfde rastercel; wisselen is
    // alleen een klasse omzetten. De CSS regelt het overvloeien en het
    // invloeien van de tekst.
    function toon(id) {
      slides.forEach(function (s) {
        var actief = s.id === id;
        s.classList.toggle("is-active", actief);
        s.setAttribute("aria-hidden", actief ? "false" : "true");
      });
      markeerDots(id);
    }

    /* ---- automatisch doorgaan ----
       Pauzeert bij muis of toetsenbordfocus en wanneer het tabblad naar
       de achtergrond gaat. Kiest de bezoeker zelf een slide, dan stopt
       het helemaal: dan heeft hij de besturing overgenomen. */
    var interval = parseInt(root.dataset.autoplay, 10) || 0;
    var timer = null;

    function huidigeIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains("is-active")) return i;
      }
      return 0;
    }

    function naarVolgende() {
      var n = (huidigeIndex() + 1) % slides.length;
      toon(slides[n].id);
    }

    function startAuto() {
      if (!interval || rustig || timer) return;
      timer = window.setInterval(naarVolgende, interval);
    }

    function pauzeerAuto() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function stopAuto() {
      pauzeerAuto();
      interval = 0;
    }

    if (interval && !rustig) {
      root.addEventListener("mouseenter", pauzeerAuto);
      root.addEventListener("mouseleave", startAuto);
      root.addEventListener("focusin", pauzeerAuto);
      root.addEventListener("focusout", startAuto);
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { pauzeerAuto(); } else { startAuto(); }
      });
      startAuto();
    }

    /* ---- vegen op mobiel ----
       Alleen op aanraakschermen en alleen als de beweging duidelijk
       horizontaal is, anders kaap je het verticaal scrollen. */
    if (root.dataset.swipe === "true") {
      var startX = null, startY = null, bezigMetVegen = false;

      root.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        bezigMetVegen = false;
      }, { passive: true });

      root.addEventListener("touchmove", function (e) {
        if (startX === null) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        // Zodra duidelijk is dat het horizontaal is, markeren we de veeg.
        if (!bezigMetVegen && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          bezigMetVegen = true;
        }
      }, { passive: true });

      root.addEventListener("touchend", function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        startY = null;

        if (!bezigMetVegen) return;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;

        // Zelf vegen betekent de besturing overnemen, net als een klik
        // op een van de knopjes.
        stopAuto();

        var i = huidigeIndex();
        var n = dx < 0 ? i + 1 : i - 1;
        if (n < 0) n = slides.length - 1;
        if (n >= slides.length) n = 0;
        toon(slides[n].id);
      }, { passive: true });
    }

    /* ---- navigatie ---- */
    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        stopAuto();
        toon(d.dataset.target);
      });

      // Pijltjestoetsen, zodat de navigatie ook zonder muis werkt.
      d.addEventListener("keydown", function (e) {
        var i = dots.indexOf(d);
        var doel = null;
        if (e.key === "ArrowRight") doel = dots[(i + 1) % dots.length];
        if (e.key === "ArrowLeft") doel = dots[(i - 1 + dots.length) % dots.length];
        if (!doel) return;
        e.preventDefault();
        stopAuto();
        doel.focus();
        toon(doel.dataset.target);
      });
    });
  }

  /* ---- reviewcarrousel ----
     Scrollt per kaart. De pijlen verschijnen alleen als er meer is dan
     er past, en worden uitgezet zodra je aan het begin of eind bent. */
  function initRevs(root) {
    if (root.dataset.hhRevInit === "1") return;
    root.dataset.hhRevInit = "1";

    var track = root.querySelector("[data-hh-rev-track]");
    // Er kunnen twee sets pijlen zijn: rechtsboven voor desktop en onder
    // de rij voor mobiel. Ze bedienen dezelfde rij.
    var navs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-rev-nav]"));
    var prevs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-rev-prev]"));
    var nexts = Array.prototype.slice.call(root.querySelectorAll("[data-hh-rev-next]"));
    if (!track || !navs.length) return;

    function stap() {
      var kaart = track.querySelector("li");
      if (!kaart) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || "0") || 0;
      return kaart.getBoundingClientRect().width + gap;
    }

    function ververs() {
      // Een marge van een paar pixels, want browsers ronden scrollposities af.
      var speling = track.scrollWidth - track.clientWidth;
      var teWeinig = speling <= 2;
      navs.forEach(function (n) { n.hidden = teWeinig; });
      prevs.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      nexts.forEach(function (b) { b.disabled = track.scrollLeft >= speling - 2; });
    }

    prevs.forEach(function (b) {
      b.addEventListener("click", function () { track.scrollBy({ left: -stap(), behavior: "smooth" }); });
    });
    nexts.forEach(function (b) {
      b.addEventListener("click", function () { track.scrollBy({ left: stap(), behavior: "smooth" }); });
    });

    var timer;
    track.addEventListener("scroll", function () {
      clearTimeout(timer);
      timer = setTimeout(ververs, 80);
    });

    window.addEventListener("resize", function () {
      clearTimeout(timer);
      timer = setTimeout(ververs, 120);
    });

    ververs();
  }

  function start(scope) {
    var s = scope || document;
    s.querySelectorAll("[data-hh-hero]").forEach(initHero);
    s.querySelectorAll("[data-hh-revs]").forEach(initRevs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { start(); });
  } else {
    start();
  }

  // Theme editor: opnieuw initialiseren na het herladen van een sectie.
  document.addEventListener("shopify:section:load", function (e) {
    var hero = e.target.querySelector("[data-hh-hero]");
    if (hero) initHero(hero);
    var revs = e.target.querySelector("[data-hh-revs]");
    if (revs) initRevs(revs);
  });

  // Springt in de editor naar de slide die je aan het bewerken bent.
  document.addEventListener("shopify:block:select", function (e) {
    var slide = e.target.closest ? e.target.closest("[data-hh-slide]") : null;
    if (!slide) return;
    var root = slide.closest("[data-hh-hero]");
    if (!root) return;
    var dot = root.querySelector('[data-hh-dot][data-target="' + slide.id + '"]');
    if (dot) dot.click();
  });
})();